/* eslint-disable jsx-a11y/click-events-have-key-events */

import React from 'react';
import { compose } from 'redux';
import { withTranslation } from 'next-i18next';

import Message from 'src/shared/config/Message';
import FieldTitle from '../components/FieldTitle';

import styles from '../styles.module.scss';

const FieldTitleContainer = (props) => (
    <div className={styles.fieldTitleContainer}>
        <FieldTitle {...props} />
    </div>
);

const ResendMessage = compose(withTranslation())((props) => {
    const { t, time, isDisabled, onResendClick } = props;

    return (
        <div className={`${styles.content} ${styles.resendMessageContainer}`}>
            <div>{t('otp-ask-if-received')}</div>
            <div>
                <span role="button" data-test="resendCodeButton" className={styles.fakeLink} disabled={isDisabled} onClick={onResendClick}>
                    {t('resend')}
                </span>
                <span>&nbsp;{t('otp-new-code-countdown', { time })}</span>
            </div>
        </div>
    );
});

const getStepTwoFields = (t, time, localFormData, isResendDisabled, isSubmitting, onResendClick) => [
    {
        controlId: 'passcode',
        className: styles.passcodeInput,
        beforeRenderer: <FieldTitleContainer title={t('otp-field-title')} />,
        type: 'numeric',
        label: t('field_OTP'),
        autoComplete: 'off',
        afterRenderer: <ResendMessage time={time} isDisabled={isResendDisabled || isSubmitting} onResendClick={onResendClick} />,
        value: localFormData.passcode,
        validate: {
            required: true,
            message: t(Message.FIELD_REQUIRED),
        },
    },
];

export default getStepTwoFields;
